import type { ReactElement } from 'react';
import { cn } from '@fshr/shared-react';
import Tree from '../../../icon/tree';

type Props = {
	className?: string;
	iconClassName?: string;
};

const R = 73;
const CIRCUMFERENCE = 2 * Math.PI * R;
const QUARTER_ARC = CIRCUMFERENCE / 4;

export default function LoadingTreeSpinner({ className, iconClassName }: Props = {}): ReactElement {
	return (
		<div
			className={cn('flex items-center justify-center p-400', className)}
			data-testid="loading-tree-spinner"
			aria-live="polite"
			aria-busy="true"
		>
			<div className="relative">
				<Tree height={90} width={90} className={cn('text-text-heading', iconClassName)} />
				<div className="absolute left-1/2 top-1/2 h-[163%] w-[163%] -translate-x-1/2 -translate-y-1/2">
					<svg
						className="h-full w-full animate-spin text-text-heading [animation-duration:2s]"
						viewBox="0 0 148 148"
						fill="none"
						aria-hidden="true"
					>
						<circle
							cx={R}
							cy={R}
							r={R}
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeDasharray={`${QUARTER_ARC} ${CIRCUMFERENCE}`}
						/>
					</svg>
				</div>
			</div>
		</div>
	);
}
